import { api } from '@/utils';

export const recurlyPaymentCheckoutAction = async (data) =>
  api(`/subscriptions/recurly`, data, 'POST');

export const recurlyPaymentQuizAction = async (code, data) =>
  api(`/open_test/${code}/subscriptions/recurly`, data, 'POST');
